import styled from 'styled-components/macro';

import TitledContent from '../TitledContent';
import BannerContent from '../BannerContent';
import { fontSize } from '../../styles/mixins';
import media from '../../styles/media';
import Banner from '../Banner';

export const BannerContentColumns = styled(BannerContent)`
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: 25px;
  color: ${({ theme }) => theme.bannerBgColor};

  height: 100%;
`;
export const StyledBanner = styled(Banner)`
  & h2 {
    margin-bottom: 30px;
  }
`;
export const ColumnWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: flex-start;
  flex-basis: 33.3%;
  min-height: 55px;
  height: 100%;
  &:not(:nth-child(1)) {
    margin-left: 25px;
  }
  &:not(:last-child) {
    padding-right: 25px;
    border-right: 1px solid ${({ theme }) => theme.bannerBorderColor};
  }
`;

export const ColumnContent = styled(TitledContent)`
  label,
  p {
    color: ${({ theme }) => theme.bannerTextColor};
  }
  label {
    ${fontSize(10)};
  }
  p {
    ${fontSize(12)};
    ${media.desktop`
      ${fontSize(18)};
    `}
  }
  &.biggerContent {
    p {
      ${media.desktop`
          ${fontSize(32)};
      `}
    }
  }
`;

export const TitledCurrency = styled(ColumnContent)`
  p {
    ${fontSize(18)};
    small {
      ${fontSize(10)};
      ${media.desktop`
          ${fontSize(22)};
      `}
    }
    span {
      font-weight: normal;
      ${fontSize(10)};
      ${media.desktop`
          ${fontSize(16)};
        `}
    }
  }
`;
